import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SocialShare from './SocialShare';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import socialShareTwStyles from './socialShare-tw-styles';
import CopyLink from './CopyLink';
import path from '../../../assets/images/svgImages.svg';
import i18nMessages from '../../../constants/messages/pt-BR';

const spritePath = typeof path === 'string' ? path : path?.src || '';

class SocialShareApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavDialog: false,
      copyDialogState: false,
    };
  }

  selectedApp = appType => {
    const { setSelectedApp, isDesk } = this.props;
    const { isNavDialog } = this.state;
    isDesk
      ? setSelectedApp(appType, true, true)
      : setSelectedApp(appType, !isNavDialog, true);
  };
  toggleCopyDialog = () => {
    const { copyDialogState } = this.state;
    this.setState({ copyDialogState: !copyDialogState });
  };
  render() {
    const {
      appSelected,
      socialShareData,
      isNavDialog,
      isMobile,
      closeNavDialog,
      shareDescription,
      shareImage,
      locale,
    } = this.props;
    return (
      <Fragment>
        {isNavDialog ? (
          <SocialShare
            type={appSelected}
            isNavShareButton
            isMobile={isMobile}
            closeNavDialog={closeNavDialog}
          />
        ) : (
          <Fragment>
            {isMobile ? <CopyLink locale={locale} /> : null}
            {socialShareData.map((socialShare, key) => {
              const { appType } = socialShare;
              if (appType === i18nMessages.whatsApp && !isMobile) {
                return;
              }
              return (
                <SocialShare
                  key={key}
                  type={appType}
                  {...socialShare}
                  isNavShareButton={false}
                  isMobile={isMobile}
                  closeNavDialog={closeNavDialog}
                  shareImage={shareImage}
                  shareDescription={shareDescription}
                  ariaLabel={`Compartilhar no ${appType}`}
                  className={classNames(
                    'share-btn sm:flex sm:flex-col-reverse justify-center items-center'
                  )}
                >
                  <Typography
                    component="span"
                    className={classNames(socialShareTwStyles.appText)}
                  >
                    {appType != i18nMessages.whatsApp
                      ? appType
                      : isMobile
                      ? appType
                      : null}
                  </Typography>
                  <div
                    className={classNames(
                      socialShareTwStyles.imageWrappingDiv
                    )}
                    aria-hidden="true"
                  >
                    <svg
                      className={classNames(
                        socialShareTwStyles.iconStyles,
                        'w-40 h-20'
                      )}
                    >
                      <use xlinkHref={`${spritePath}#${appType}`} />
                    </svg>
                  </div>
                </SocialShare>
              );
            })}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

SocialShareApps.propTypes = {
  appSelected: PropTypes.string,
  socialShareData: PropTypes.instanceOf(Array),
  closeNavDialog: PropTypes.func.isRequired,
  isNavDialog: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  isNavShareButton: PropTypes.bool,
  shareImage: PropTypes.string,
  shareDescription: PropTypes.string,
  locale: PropTypes.string,
};

SocialShareApps.defaultProps = {
  appSelected: '',
  shareImage: '',
  shareDescription: '',
  locale: 'pt-BR',
  socialShareData: [
    {
      appType: 'Facebook',
    },
  ],

  isNavShareButton: false,
  isMobile: false,
};

export default SocialShareApps;
